import {
    defineStore,
} from 'pinia';
import {
    computed, reactive, toRefs,
} from 'vue';
import {
    createInterest,
} from '../models/Interest';

export const DEFAULT_INTEREST = {
    id: null,
    label: '',
};

export const useInterestStore = defineStore('profile-interest', () => {
    const state = reactive({
        interests: [],
    });

    function updateFromQuery(data) {
        // The default row is merged to make sure all necessary fields are initialized.
        state.interests = data.map(interest => ({
            ...DEFAULT_INTEREST,
            id: interest.id,
            label: interest.name,
        }));
    }

    const models = computed(() => state.interests.map(x => createInterest(x)));
    const count = computed(() => state.interests.length);
    const filled = computed(() => state.interests.length > 0);

    return {
        ...toRefs(state),
        updateFromQuery,
        models,
        count,
        filled,
    };
});
